var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("footer", { staticClass: "bar third" }, [
      _c("div", { staticClass: "footer" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }